import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";

interface EditDescriptionModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string | null;
  onSave: (newDescription: string | null) => void;
  itemName?: string;
}

export function EditDescriptionModal({
  open,
  onOpenChange,
  title,
  description,
  onSave,
  itemName,
}: EditDescriptionModalProps) {
  const [value, setValue] = useState(description ?? "");

  useEffect(() => {
    if (open) {
      setValue(description ?? "");
    }
  }, [open, description]);

  const handleSave = () => {
    const trimmed = value.trim();
    onSave(trimmed || null);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {itemName && <DialogDescription>Editing description for {itemName}</DialogDescription>}
        </DialogHeader>
        <Textarea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="Enter description..."
          className="min-h-[200px]"
        />
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button onClick={handleSave}>Save</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
